<template>
  <div class="cpt-game-categoty">
    <div class="game-image-wrapper" :class="{ voting: !hasTgaResult }">
      <div class="game-mask" v-if="!hasTgaResult">
        <div class="game-count">
          <span>{{ gameList.length }}</span
          >款
        </div>
        <div class="category-status">
          <div class="text">正在公布</div>
          <CptDotLoading></CptDotLoading>
        </div>
      </div>
      <img class="game-image" v-src="award.img" />
      <div class="decorator" v-if="!hasTgaResult">
        <div class="min-decorator"></div>
      </div>
    </div>
    <div class="category-info-wrapper">
      <div class="info-top-wrapper">
        <div class="category-eng-name">{{ award.sub_title }}</div>
        <div class="category-cn-game">{{ award.title }}</div>
        <div class="category-nominees" v-if="!hasTgaResult">
          {{ award.desc }}
        </div>
        <div class="vote-result-box" v-else>
          <p class="tga-result">{{ tgaResultDesc }}</p>
        </div>
      </div>
      <div class="info-bottom-wrapper">
        <div class="my-vote-result" v-if="myVotedGame">{{ myVotedDesc }}</div>
        <div
          class="vote-btn"
          v-if="!hasTgaResult"
          :class="[voteBtnClass]"
          @click="showVoteModal"
        >
          {{ voteBtnDesc }}
        </div>
        <div class="vote-btn" v-else @click="showResultModal">查看</div>
      </div>
    </div>
  </div>
</template>

<script>
import CptDotLoading from './cpt-dot-loading.vue';
export default {
  components: {
    CptDotLoading,
  },
  props: {
    award: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasTgaResult() {
      return Boolean(this.award.tga_result); // || true
    },
    hasMyResult() {
      return Boolean(this.award.my_result);
    },
    gameList() {
      return this.award.items || [];
    },
    voteBtnClass() {
      return !this.hasTgaResult && this.hasMyResult ? 'disabled' : '';
    },
    voteBtnDesc() {
      return this.hasMyResult ? '已投票' : '查看';
    },
    myVotedGame() {
      return this.gameList.find((item) => item.key == this.award.my_result);
    },
    tgaResultGame() {
      return this.gameList.find((item) => item.key == this.award.tga_result);
    },
    tgaResultDesc() {
      if (this.tgaResultGame.appid) {
        return `TGA获奖: 《${this.tgaResultGame.name}》`;
      } else {
        return `TGA获奖: ${this.tgaResultGame.name}`;
      }
    },
    myVotedDesc() {
      if (this.myVotedGame.appid) {
        return `投给了《${this.myVotedGame.name}》`;
      } else {
        return `投给了${this.myVotedGame.name}`;
      }
    },
  },
  methods: {
    showVoteModal() {
      if (!this.hasTgaResult) {
        this.$emit('vote', this.award);
      }
    },
    showResultModal() {
      this.$emit('result', this.award);
    },
  },
};
</script>

<style lang="less">
.cpt-game-categoty {
  width: 100%;
  height: 195px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  &:not(:last-child) {
    margin-bottom: 40px;
  }
  .game-image-wrapper {
    width: 130px;
    height: 195px;
    flex-shrink: 0;
    position: relative;
    .game-mask {
      position: absolute;
      width: 130px;
      height: 195px;
      border-radius: 3px;
      border-radius: 3px;
      border: 0.5px solid #232425;
      background: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(5px);
      box-sizing: border-box;
      z-index: 4;
      .game-count {
        position: absolute;
        top: 8px;
        right: 8px;
        border-radius: 2px;
        height: 22px;
        padding: 0 8px;
        background: #000;
        color: #fff;
        font-family: 'PingFang SC';
        font-size: 10px;
        font-weight: 400;
        line-height: 22px;
        span {
          color: #fff;
          font-family: 'Gellix TRIAL';
          font-size: 14px;
          font-weight: 600;
          margin-right: 1px;
          position: relative;
          top: -1px;
        }
      }
      .category-status {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 16px;
        display: flex;
        flex-direction: row;
        align-items: baseline;
        justify-content: center;
        .text {
          color: #e0e0e0;
          font-family: 'PingFang SC';
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
        }
        .loading-indicator {
          margin-left: 4px;
        }
      }
    }

    .game-image {
      width: 130px;
      height: 195px;
      border-radius: 3px;
      position: relative;
      z-index: 3;
      object-fit: cover;
    }
    .decorator {
      width: 116px;
      height: 175px;
      border-radius: 3px;
      background: #1c1d1e;
      position: absolute;
      top: 10px;
      left: 24px;
      z-index: 2;
      .min-decorator {
        width: 123px;
        height: 185px;
        border-radius: 3px;
        position: absolute;
        top: -5px;
        left: -12px;
        background: #232425;
        z-index: 1;
      }
    }
  }
  .category-info-wrapper {
    margin-left: 20px;
    height: 100%;
    flex: 1;
    width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .info-top-wrapper {
      .category-eng-name {
        height: 16px;
        color: #405a8c;
        font-family: 'Gellix TRIAL';
        font-size: 14px;
        font-weight: 600;
      }
      .category-cn-game {
        margin-top: 5px;
        color: #fff;
        line-height: 22px;
        font-family: 'PingFang SC';
        font-size: 16px;
        font-weight: 600;
      }
      .category-nominees {
        margin-top: 10px;
        color: #64696e;
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 300;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .vote-result-box {
        height: 0;
        flex: 1;
        margin-top: 10px;
        position: relative;
        p {
          height: 20px;
          line-height: 20px;
          font-size: 12px;
          color: #64696e;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.tga-result {
            color: #e0e0e0;
          }
        }
      }
    }
    .info-bottom-wrapper {
      .my-vote-result {
        width: 100%;
        margin-bottom: 12px;
        color: #e0e0e0;
        font-family: 'PingFang SC';
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .vote-btn {
        width: 81px;
        height: 32px;
        border-radius: 3px;
        background: #3366ca;
        color: #fff;
        font-family: 'PingFang SC';
        font-size: 13px;
        font-weight: 500;
        line-height: 32px;
        text-align: center;
        &.disabled {
          background: #232425;
          color: #64696e;
        }
      }
    }
  }
}
</style>
